module.exports = __webpack_public_path__ + "static/media/schoolbus.5b3c5053.png";